import { render, staticRenderFns } from "./BaseInputTime.vue?vue&type=template&id=45f28587&scoped=true&"
import script from "./BaseInputTime.vue?vue&type=script&lang=ts&"
export * from "./BaseInputTime.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputTime.vue?vue&type=style&index=0&id=45f28587&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f28587",
  null
  
)

export default component.exports